<template>
  <div class="member-setting">
    <div class="setting-content">
      <div class="setting-tip">
        <p>从项目中移除
          <MyAvatar :userName="memberInfo.realname" :imgUrl="memberInfo.user_avatar" width="28px" height="28px">{{memberInfo.realname}}</MyAvatar>
        </p>
        <div class="member-setting-text">
          <i class="icon iconfont icontishi"></i>
          <span>被移除的成员将不能再访问该项目的信息,但跟他相关的信息不会被删除</span>
        </div>
        <!-- <div class="member-setting-text">
          <span>文慢慢 在2020-08-03 由项目创建者 张安好 邀请进入项目</span>
        </div> -->
        <wf-button style="margin-top: 20px;" type="danger" plain @click="delProjectMember">了解，移除该成员</wf-button>
      </div>
      <el-form label-position="top" label-width="80px" :model="form">
        <el-form-item label="项目中的权限">
          <!-- <el-radio-group v-model="form.type">
            <el-radio :label="2"></el-radio>
            <el-radio :label="0">项目成员</el-radio>
          </el-radio-group> -->
          <el-checkbox-group v-model="form.type">
            <el-checkbox label="2" @change="check('2')">管理员</el-checkbox>
            <el-checkbox label="0" @change="check('0')">项目成员</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <!-- <el-form-item label="">
          <el-button type="primary" :disabled="form.type === init" @click="submit">保存设置</el-button>
        </el-form-item> -->
      </el-form>
    </div>
    <div class="footer-btns">
      <div></div>
      <div>
        <wf-button plain style="margin-right:20px;" @click="$emit('cancel')">取 消</wf-button>
        <wf-button type="primary" :disabled="form.type === init" @click="submit" :loading="loading">保 存</wf-button>
      </div>
    </div>
  </div>
</template>

<script>
import MyAvatar from '@/components/avatar'
import Api from "@/services/api/project/project"
export default {
  name: "MemberSetting",
  components: {
    MyAvatar
  },
  props: {
    projectId: {
      type: Number,
      default: 0
    },
    memberInfo: {
      type: Object,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      admincheck: false,
      projectmember: false,
      form: {
        type: ['1']
      },
      realname: '',
      loading: false
    }
  },
  created() {
    this.init = this.memberInfo.type;
    this.form.type = [this.memberInfo.type + '']
    this.realname = this.memberInfo.realname;
  },
  methods: {
    delProjectMember() {
      // this.$emit("removeMember", this.memberInfo.uid)
      Api.deleteProjectMember({
        project_id: this.projectId,
        member: [this.memberInfo.uid]
      }).then(res => {
        this.$message({
          message: "操作成功",
          type: "success"
        })
        this.$emit("success")
      })
    },
    submit() {
      Api.updateprojectmemberrole({
        'project_id': this.projectId,
        'uid': this.memberInfo.uid,
        'type': this.form.type[0]
      }).then(res => {
        this.$message({
          message: "设置成功",
          type: "success"
        })
        this.$emit("success")
      })
    },
    check(type) {
      console.log(type)
      this.form.type = []
      this.form.type = [type]
    },
  }
}
</script>

<style lang="scss" scoped>
.member-setting {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  ::v-deep {
    .el-form-item__label {
      font-size: 16px;
      color: #0d1f3c;
    }
  }
}
.setting-tip {
  padding: 20px 0;
  opacity: 0.8;
  font-size: 14px;
  color: initial;
  .member-setting-text {
    display: flex;
    margin-top: 24px;
    line-height: 16px;
    color: rgba(32, 32, 32, 0.6);
    i {
      color: #b0b6bf;
      margin-right: 10px;
    }
  }
  .avatar-box {
    margin-left: 20px;
  }
}
.setting-tip > p {
  font-size: 16px;
  display: flex;
  align-items: center;
}
</style>
